import React from 'react';
import Card from '../ui/Card';

interface PropertyCardProps {
  image: string;
  title: string;
  price: string;
  bedrooms: number;
  bathrooms: number;
  area: string;
  tag?: string;
  onImageClick?: (image: string, title: string) => void;
  className?: string;
}

const PropertyCard: React.FC<PropertyCardProps> = ({
  image,
  title,
  price,
  bedrooms,
  bathrooms,
  area,
  tag,
  onImageClick,
  className = ''
}) => {
  return (
    <Card 
      hover={true}
      padding="none"
      className={`overflow-hidden ${className}`}
    >
      <div className="relative cursor-pointer" onClick={() => onImageClick && onImageClick(image, title)}>
        <img
          src={image}
          alt={title}
          className="w-full h-48 object-cover"
        />
        {tag && (
          <div className="absolute top-4 left-4 bg-secondary px-3 py-1 rounded-full text-sm font-medium" style={{ color: 'black' }}>
            {tag}
          </div>
        )}
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-bold text-primary mb-2">{title}</h3>
        <p className="text-2xl font-bold text-secondary mb-4">{price}</p>
        
        <div className="flex items-center justify-between text-gray-600">
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2V7z" />
            </svg>
            <span className="text-sm">{bedrooms} bed</span>
          </div>
          
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10v11M20 10v11" />
            </svg>
            <span className="text-sm">{bathrooms} bath</span>
          </div>
          
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
            </svg>
            <span className="text-sm">{area}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default PropertyCard;